import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import PunchCard from '../order.loyalty/punch-card';
import PostConfirmationStatus from '@/common/order.post-confirmation-status/PostConfirmationStatus';

const OrderConfirmationSuccess = ({ order }) => {
    const [t] = useTranslation('order.confirmation');

    const expected_at_string = t(`ready_for_${order.getMethod()}`, {
        time: t('common:time', {
            time: order.getExpectedAt(),
        }),
    });

    return (
        <div className="m2g-order-confirmation-success">
            <span className="m2g-order-confirmation-success-icon m2g-icon m2g-icon--tick-circle" />

            <PostConfirmationStatus />

            <div className="m2g-order-confirmation-success-expected-at-message m2g-text--emphasise">
                {expected_at_string}
                {!order.isExpectedToday() && (
                    <div>{order.getExpectedAt().format('dddd, Do MMMM')}</div>
                )}
            </div>

            <div className="m2g-order-confirmation-success-email-message">
                {t('email_confirmation_shortly')}
            </div>

            <PunchCard is_showing_in_confirmation />
        </div>
    );
};

OrderConfirmationSuccess.propTypes = {
    order: PropTypes.shape({}).isRequired,
};

export default memo(OrderConfirmationSuccess);
